var map = {
	"./add.svg": "f8d4",
	"./back.svg": "9ce9",
	"./duplicate.svg": "5b68",
	"./edit.svg": "68bf",
	"./print.svg": "61dc",
	"./trash.svg": "7179"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cff8";